var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0796 0.679932H0.919609C0.743609 0.679932 0.599609 0.823932 0.599609 0.999932V8.99993C0.599609 9.17593 0.743609 9.31993 0.919609 9.31993H13.0796C13.2556 9.31993 13.3996 9.17593 13.3996 8.99993V0.999932C13.3996 0.823932 13.2556 0.679932 13.0796 0.679932ZM12.3116 1.31993L6.99961 6.63193L1.68761 1.31993H12.3116ZM1.23961 1.76793L4.47161 4.99993L1.23961 8.23193V1.76793ZM1.70361 8.67993L4.91961 5.46393L6.77561 7.31993C6.90361 7.44793 7.09561 7.44793 7.22361 7.31993L9.07961 5.46393L12.2956 8.67993H1.70361ZM12.7596 8.23193L9.52761 4.99993L12.7596 1.76793V8.23193Z",
    fill: "#1E456A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b85b6d79e92515f2a092570c981dfc28.svg";
export { ForwardRef as ReactComponent };